import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, message } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import CondPagtoFrame from './CondPagtoFrame';
import PedidoItemForm from './PedidoItemForm';
import PedidoItemEntregaForm from './PedidoItemEntregaForm';
import PedidoItemGradeForm from './PedidoItemGradeForm';
import TituloParcelaForm from './TituloParcelaForm';
import OrdemProducaoForm from '../components/OrdemProducaoForm';
// import ModalPadraoForm from './ModalPadraoForm';
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from "../utils/Colors";


const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;


export const OPCOES_TIPO = [
  { key: 'P', label: 'PEDIDO' },
  { key: 'O', label: 'ORÇAMENTO' },
  { key: 'B', label: 'BONIFICAÇÃO' },
]

export const OPCOES_TIPO1 = [
  { key: 'P', label: 'PEDIDO' },
  { key: 'O', label: 'ORÇAMENTO' },
]

export const OPCOES_TIPO_FRETE = [
  { key: 'CIF', label: 'FRETE EMPRESA' },
  { key: 'FOB', label: 'FRETE CLIENTE' },
]

export default class PedidoForm extends Component {
  state = {
    registro: {
      ven_idf: 0,
      ven_numero: '',
      ven_dt_venda: moment().format('DD/MM/YYYY'),
      ven_obs: '',
      ven_qtde_itens: 0,
      ven_vlr_itens: 0,
      ven_vlr_acres: 0,
      ven_vlr_frete: 0,
      ven_vlr_desc: 0,
      ven_vlr_total: 0,
      ven_filial: '',
      ven_tipo_venda: { key: 'P' },
      ven_tipo_frete: { key: 'CIF' },
      ven_pessoa: { key: '0' },
      ven_usuario: { key: '0' },
      ven_cond_pagto: { key: '0' },
      ven_latitude: 0,
      ven_longitude: 0,
    },
    modalProdutoVisible: false,
    modalEntregaVisible: false,
    modalGradeVisible: false,
    modalParcelaVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    editando: false,
    visualizando: false,

    activeKey: "dados",

    listaProdutos: [],
    listaEntregas: [],
    listaGrades: [],
    listaParcelas: [],
    OPCOES_FILIAL: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      // console.log('componentDidUpdate', this.props)

      const usuario = getUsuario();
      let OPCOES_FILIAL = [];
      if (usuario.emp_filial1) {
        OPCOES_FILIAL = [
          { key: usuario.emp_filial, label: usuario.emp_filial },
          { key: usuario.emp_filial1, label: usuario.emp_filial1 },
        ]
      }

      this.setState({
        registro: this.props.registroSelecionado.dados,
        ven_pessoa: this.props.registroSelecionado.dados.ven_pessoa,
        ven_usuario: this.props.registroSelecionado.dados.ven_usuario,
        ven_cond_pagto: this.props.registroSelecionado.dados.ven_cond_pagto,
        listaProdutos: this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : [],
        listaEntregas: this.props.registroSelecionado.listaEntregas ? this.props.registroSelecionado.listaEntregas : [],
        listaGrades: this.props.registroSelecionado.listaGrades ? this.props.registroSelecionado.listaGrades : [],
        listaParcelas: this.props.registroSelecionado.listaParcelas ? this.props.registroSelecionado.listaParcelas : [],
        visualizando: this.props.registroSelecionado.dados.visualizando,
        usuario,
        OPCOES_FILIAL,
        editando: false,
        activeKey: "dados",
      }, () => {
        this.calculoTotalPedido(this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : []);
      });

      if (this.props.registroSelecionado.dados.ven_idf) {
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    });
  }

  onOK = () => {
    if ((!this.state.registro.ven_dt_venda) || (!moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.ven_pessoa) || (this.state.registro.ven_pessoa.key === '0') || (this.state.registro.ven_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((!this.state.registro.ven_usuario) || (this.state.registro.ven_usuario.key === '0') || (this.state.registro.ven_usuario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Vendedor', });
      return;
    }
    if ((!this.state.registro.ven_cond_pagto) || (this.state.registro.ven_cond_pagto.key === '0') || (this.state.registro.ven_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }
    if ((!this.state.registro.ven_tipo_frete) || (this.state.registro.ven_tipo_frete.key === '0') || (this.state.registro.ven_tipo_frete.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe tipo de Frete', });
      return;
    }
    if ((!this.state.registro.ven_filial) || (this.state.registro.ven_filial === '0') || (this.state.registro.ven_filial === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Filial', });
      return;
    }
    if ((!this.state.listaProdutos) || (this.state.listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto na Venda' });
      return;
    }
    if ((!this.state.listaParcelas) || (this.state.listaParcelas.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Parcelas não informadas' });
      return;
    }


    // VERIFICA A QTDE DA GRADE TAMANHO
    if ((this.state.listaGrades) && (this.state.listaGrades.length > 0)) {
      for (var y in this.state.listaProdutos) {
        const prod = this.state.listaProdutos[y].prod_idf
        const qtdeProd = this.state.listaProdutos[y].vi_qtde

        let qtdeGrade = 0
        for (var x in this.state.listaGrades) {
          if (prod === this.state.listaGrades[x].vig_item) {
            qtdeGrade = qtdeGrade + parseFloat(this.state.listaGrades[x].vig_qtde);
          }
        };
        if (qtdeGrade) {
          let qtdeDif = parseFloat((parseFloat(qtdeGrade) - parseFloat(qtdeProd)).toFixed(2));
          if (qtdeDif !== 0) {
            Modal.warning({ title: 'Aviso!', content: 'Qtde de cada tamanho na grade é diferente da quantidade total dos itens' });
            return;
          }
        }
      }
    }

    // VERIFICA A QTDE DE ENTREGAS
    if ((this.state.listaEntregas) && (this.state.listaEntregas.length > 0)) {
      for (var y in this.state.listaProdutos) {
        const prod = this.state.listaProdutos[y].prod_idf
        const qtdeProd = this.state.listaProdutos[y].vi_qtde

        let qtdeEntregas = 0
        for (var x in this.state.listaEntregas) {
          if (prod === this.state.listaEntregas[x].vie_item) {
            qtdeEntregas = qtdeEntregas + parseFloat(this.state.listaEntregas[x].vie_qtde);
          }
        };
        if (qtdeEntregas) {
          let qtdeDif = parseFloat((parseFloat(qtdeEntregas) - parseFloat(qtdeProd)).toFixed(2));
          if (qtdeDif !== 0) {
            Modal.warning({ title: 'Aviso!', content: 'Qtde das entregas é diferente da quantidade total dos itens' });
            return;
          }
        }
      }
    }


    if ((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) {
      let vlrTotalParc = 0
      for (var x in this.state.listaParcelas) {
        vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].vp_valor_parcela);
      };
      let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ven_vlr_total)).toFixed(2));
      if (vlrDifParc !== 0) {
        Modal.warning({ title: 'Aviso!', content: 'O Valor Total da Venda não Confere com o Valor Total das parcelas' });
        return;
      }
    }

    const registro = {
      ven_idf: this.state.registro.ven_idf,
      ven_dt_venda: moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      ven_numero: this.state.registro.ven_numero ? this.state.registro.ven_numero : '0',
      ven_pessoa: this.state.ven_pessoa.key,
      pes_nome: this.state.ven_pessoa.label,
      ven_usuario: this.state.ven_usuario.key,
      ven_cond_pagto: this.state.registro.ven_cond_pagto ? this.state.registro.ven_cond_pagto.key : '',
      ven_vlr_itens: this.state.registro.ven_vlr_itens,
      ven_vlr_desc: this.state.registro.ven_vlr_desc,
      ven_vlr_acres: this.state.registro.ven_vlr_acres,
      ven_vlr_frete: this.state.registro.ven_vlr_frete,
      ven_vlr_total: this.state.registro.ven_vlr_total,
      ven_obs: this.state.registro.ven_obs,
      ven_dados_cliente: this.state.registro.ven_dados_cliente,
      ven_filial: this.state.registro.ven_filial.key ? this.state.registro.ven_filial.key : this.state.registro.ven_filial,
      ven_tipo_venda: this.state.registro.ven_tipo_venda.key,
      ven_tipo_frete: this.state.registro.ven_tipo_frete.key,
      ven_latitude: 0,
      ven_longitude: 0,

      listaProdutos: this.state.listaProdutos,
      listaEntregas: this.state.listaEntregas,
      listaGrades: this.state.listaGrades,
      listaParcelas: this.state.listaParcelas,
    };

    // console.log('onOK: ', registro)
    // return;

    this.props.onSalvarClick(registro);
  };

  calculoTotalPedido = (listaProdutos) => {
    // console.log('calculoTotalPedido')

    const { registro } = this.state;
    let qtdeItens = 0;
    let vlrItens = 0;
    let vlrDesc = 0;
    let vlrAcres = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      qtdeItens = qtdeItens + parseFloat(listaProdutos[x].vi_qtde);
      vlrItens = vlrItens + (parseFloat(listaProdutos[x].vi_qtde) * parseFloat(listaProdutos[x].vi_vlr_unit));
      vlrDesc = vlrDesc + parseFloat(listaProdutos[x].vi_vlr_desc);
      vlrAcres = vlrAcres + parseFloat(listaProdutos[x].vi_vlr_acres);
      vlrTotal = vlrTotal + parseFloat(listaProdutos[x].vi_vlr_total);
    };

    qtdeItens = parseFloat(qtdeItens);
    vlrItens = parseFloat(vlrItens.toFixed(2));
    vlrDesc = parseFloat(vlrDesc.toFixed(2));
    vlrAcres = parseFloat(vlrAcres.toFixed(2));
    vlrTotal = vlrTotal + parseFloat(this.state.registro.ven_vlr_frete);
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    registro.ven_qtde_itens = qtdeItens;
    registro.ven_vlr_itens = vlrItens;
    registro.ven_vlr_desc = vlrDesc;
    registro.ven_vlr_acres = vlrAcres;
    registro.ven_vlr_total = vlrTotal;
    // console.log('calculoTotalPedido3', vlrTotal)

    this.setState({
      registro,
    });
  }

  onChangeCliente = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
    this.buscaCondPagtos(event.target.value.key);
  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangeFrete = event => {
    // console.log('onChangeFrete')

    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    registro.ven_vlr_total = parseFloat(this.state.registro.ven_vlr_itens) + parseFloat(this.state.registro.ven_vlr_frete) + parseFloat(this.state.registro.ven_vlr_acres) - parseFloat(this.state.registro.ven_vlr_desc);
    // this.setState({
    //   registro,
    // });

    this.setState({
      [id]: value
    });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['ven_pessoa'] = event.ven_pessoa;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['ven_usuario'] = event.ven_usuario;
    this.setState(event);
  }



  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onFecharModalProdutoClick = () => {
    this.setState({
      modalProdutoVisible: false,
    });
  }

  onSalvarProdutoClick = (listaProdutos) => {
    this.setState({
      modalProdutoVisible: false,
      listaProdutos,
    },
      this.calculoTotalPedido(listaProdutos)
    );
  }

  onNovoProduto = (event) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: false,
        registro: {
          vi_seq: 0,
          vi_item: { key: '0' },
          prod_codigo: '',
          prod_descricao: '',
          vi_qtde: 1,
          vi_vlr_unit: 0,
          vi_vlr_venda: 0,
          vi_vlr_venda_min: 0,
          vi_perc_desc: 0,
          vi_vlr_desc: 0,
          vi_vlr_acres: 0,
          vi_vlr_total: 0,
          vi_perc_comissao: 0,
          vi_tabela: 0,
          vi_vlr_tabela: 0,
          vi_idf_producao: null,
        }
      }
    });
  }

  onEditarProdutosClick = (reg) => {
    let temGrade = false;
    const listaAuxGrd = this.state.listaGrades ? this.state.listaGrades : [];
    for (var x in listaAuxGrd) {
      if (listaAuxGrd[x].vig_item === reg.vi_item) {
        temGrade = true;
      }
    };

    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: true,
        temGrade,
        registro: {
          vi_item: {
            key: String(reg.vi_item),
            label: reg.prod_descricao,
            prod_codigo: reg.prod_codigo,
            prod_descricao: reg.prod_descricao,
            prod_preco_tab1: reg.prod_preco_tab1,
            prod_preco_tab2: reg.prod_preco_tab2,
          },
          prod_codigo: reg.prod_codigo,
          prod_descricao: reg.prod_descricao,
          vi_qtde: reg.vi_qtde,
          vi_vlr_unit: reg.vi_vlr_unit,
          vi_perc_desc: reg.vi_perc_desc,
          vi_vlr_desc: reg.vi_vlr_desc,
          vi_vlr_total: reg.vi_vlr_total,
          vi_perc_comissao: reg.vi_perc_comissao,
          vi_tabela: reg.vi_tabela,
          vi_idf_producao: reg.vi_idf_producao,
          vi_vlr_tabela: reg.vi_vlr_tabela,
        }
      }
    });
  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.prod_idf === reg.prod_idf);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
        },
          this.calculoTotalPedido(listaProdutos)
        );
      }
    })
  }





  // ----------------------------------------------------------------
  // ORDEM DE PRODUÇÃO
  // ----------------------------------------------------------------

  onEditarProducaoClick = vi_idf_producao => {
    this.setState({ carregando: true });
    axios.get(`/producao/show/${vi_idf_producao}`)
      .then(response => {
        const { data } = response;
        data.dados.op_pessoa = {
          key: String(data.dados.op_pessoa),
          label: data.dados.pes_nome,
        }
        data.dados.op_dt_emissao = moment(data.dados.op_dt_emissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        this.setState({
          formVisivelProducao: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivelProducao: false
    })
  }

  onSalvarClick = (registro) => {
    this.setState({ salvando: true })

    axios.put(`/producao/update/${registro.op_idf}`, registro)
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Produção gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }

  onAbrirLaudoAnaliseClick = registro => {
    // console.log('onAbrirLaudoAnaliseClick: ', registro);
    this.setState({ carregando: true });
    axios.post('/vendas/montaPDFLaudo', registro)
      .then(response => {
        const { data } = response;
        // console.log('onAbrirPDFClick: ', data);
        // console.log('onAbrirPDFClick: ', data.nomeArq);
        const file_url = 'https://api.p7vendas.plenasistemas.inf.br/image/emp' + this.state.usuario.emp_codigo + '/pdf/' + data.nomeArq;
        window.open(file_url, '_blank')
      }).catch(ex => {
        Modal.warning({ title: 'Aviso!', content: 'Não foi possível localizar o Laudo', });
        this.setState({ carregando: false });
        console.warn(ex);
      });

    this.setState({
      carregando: false,
    })
  };

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------





  renderAcoesProdutos = (registro) => {
    return (
      <div>
        <ButtonGroup size="small">
          {registro.vi_idf_producao && getTemPermissao('OrdemProducaoPage', 'editar') ? (
            <Tooltip title="Editar Ordem de Produção" placement="top">
              <Button style={{ backgroundColor: Colors.primaryLight, color: Colors.textPrimaryLight }} onClick={() => this.onEditarProducaoClick(registro.vi_idf_producao)} icon="medicine-box" />
            </Tooltip>
          ) : null}
          {registro.vi_idf_producao && getTemPermissao('OrdemProducaoPage', 'editar') ? (
            <Tooltip title="Imprimir Laudo da Análise" placement="top">
              <Button style={{ backgroundColor: Colors.fundoPage, color: Colors.primary, marginRight: 10 }} size="small" onClick={() => this.onAbrirLaudoAnaliseClick(registro)} icon="printer" />
            </Tooltip>
          ) : null}
          {this.state.visualizando ? null : (
            <Tooltip title="Editar" placement="top">
              <Button className="botoesModalFormEditar" onClick={() => this.onEditarProdutosClick(registro)} icon="edit" />
            </Tooltip>
          )}
          {this.state.usuario.par_entrega_itens_vendas ? (
            <Tooltip title="Entregas" placement="top">
              <Button className="botoesModalFormEditar" onClick={() => this.onEntregaProdutosClick(registro)} icon="car" />
            </Tooltip>
          ) : null}
          {this.state.usuario.par_flag_grade_produtos ? (
            <Tooltip title="Grade" placement="right">
              <Button className="botoesModalFormEditar" onClick={() => this.onGradeProdutosClick(registro)} icon="appstore" />
            </Tooltip>
          ) : null}
          {this.state.visualizando ? null : (
            <Tooltip title="Excluir" placement="top">
              <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirProdutosClick(registro)} icon="delete" />
            </Tooltip>
          )}
        </ButtonGroup>
      </div>
    );
  };




  // ----------------------------------------------------------------
  // ENTREGAS
  // ----------------------------------------------------------------

  onFecharModalEntregaClick = () => {
    this.setState({
      modalEntregaVisible: false,
    });
  }

  onEntregaProdutosClick = (reg) => {
    this.setState({
      modalEntregaVisible: true,
      produtoEntregaSelecionado: {
        editando: !this.state.visualizando,
        prod_idf: reg.prod_idf,
        vi_seq: reg.vi_seq,
        vi_qtde: reg.vi_qtde,
      }
    });
  }

  onSalvarEntregasClick = (listaEntregas) => {
    this.setState({
      modalEntregaVisible: false,
      listaEntregas,
    },
      // this.calculoTotalPedido(listaProdutos)
    );
  }




  // ----------------------------------------------------------------
  // GRADE
  // ----------------------------------------------------------------

  onFecharModalGradeClick = () => {
    this.setState({
      modalGradeVisible: false,
    });
  }

  onGradeProdutosClick = (reg) => {
    this.setState({
      modalGradeVisible: true,
      produtoGradeSelecionado: {
        editando: !this.state.visualizando,
        prod_idf: reg.prod_idf,
        vi_seq: reg.vi_seq,
      }
    });
  }

  onSalvarGradeClick = (listaGrades, reg) => {

    // console.log('onSalvarGradeClick - listaGrades: ', listaGrades);
    // console.log('onSalvarGradeClick - reg: ', reg);

    let qtdeAux = 0;
    for (var x in listaGrades) {
      if (listaGrades[x].vig_item === reg.prod_idf) {
        qtdeAux = qtdeAux + listaGrades[x].vig_qtde;
      }
    }

    // console.log('onSalvarGradeClick - qtdeAux: ', qtdeAux);
    if (qtdeAux) {

      const iIndItem = this.state.listaProdutos.findIndex(registro => registro.vi_item === reg.prod_idf);
      // console.log('onSalvarGradeCl0ick - iIndItem: ', iIndItem)
      if (iIndItem >= 0) {
        // console.log('onSalvarGradeClick - listaProdutos1: ', this.state.listaProdutos[iIndItem])

        this.state.listaProdutos[iIndItem].vi_qtde = qtdeAux;
        this.state.listaProdutos[iIndItem].vi_vlr_total = parseFloat((qtdeAux * parseFloat(this.state.listaProdutos[iIndItem].vi_vlr_unit)).toFixed(2));

        // console.log('onSalvarGradeClick - listaProdutos2: ', this.state.listaProdutos[iIndItem])
      }
    }

    this.setState({
      modalGradeVisible: false,
      listaGrades,
    },
      this.calculoTotalPedido(this.state.listaProdutos)
    );
  }





  // ----------------------------------------------------------------
  // PARCELAS
  // ----------------------------------------------------------------

  montaParcelas = () => {
    let listaNova = [];
    if ((!this.state.registro.ven_cond_pagto) || (this.state.registro.ven_cond_pagto.key === '0') || (this.state.registro.ven_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }

    if (parseFloat(this.state.registro.ven_vlr_total) > 0) {
      const parcelas = this.state.registro.ven_cond_pagto.parcelas;
      // console.log('montaParcelas - parcelas: ', parcelas);

      var listaParelas = parcelas.split(',');
      // const listaParelas = ['5', '10', '15'];
      // console.log('montaParcelas - listaParelas: ', listaParelas);

      const w_Qtde_Parc = listaParelas.length;// parseInt(this.state.registro.ven_cond_pagto.qtdeParc);
      // console.log('montaParcelas - w_Qtde_Parc: ', w_Qtde_Parc);

      const w_Data_Venda = moment(this.state.registro.ven_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD');
      let w_Data_Parc = '';
      // console.log('montaParcelas - w_Data_Parc: ', w_Data_Parc);

      let w_Valor_Parc = parseFloat(parseFloat(this.state.registro.ven_vlr_total) / w_Qtde_Parc).toFixed(2);
      // console.log('montaParcelas - w_Valor_Parc: ', w_Valor_Parc);


      let iParc = 1;
      while (iParc <= w_Qtde_Parc) {
        // w_Data_Parc = moment(w_Data_Parc).subtract(-1, 'months').format('YYYY-MM-DD');

        w_Data_Parc = moment(w_Data_Venda).add(listaParelas[iParc - 1], 'days').format('YYYY-MM-DD')
        // console.log('montaParcelas - w_Data_Parc: ', w_Data_Parc);

        listaNova.push({
          vp_parcela: iParc,
          vp_data_parcela: w_Data_Parc,
          vp_valor_parcela: w_Valor_Parc,
        })
        iParc++;
      }

      if ((listaNova) && (listaNova.length > 0)) {
        let vlrTotalParc = 0;
        for (var x in listaNova) {
          vlrTotalParc = vlrTotalParc + parseFloat(listaNova[x].vp_valor_parcela);
        };
        if (parseFloat(vlrTotalParc) !== parseFloat(this.state.registro.ven_vlr_total)) {
          let vlrDif = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ven_vlr_total)).toFixed(2));
          vlrDif = vlrDif * (-1);
          const vlr = (parseFloat(listaNova[0].vp_valor_parcela) + parseFloat(vlrDif)).toFixed(2);
          listaNova[0].vp_valor_parcela = vlr;
        }
      }
    }

    // console.log('listaNova: ', listaNova);

    this.setState({
      listaParcelas: listaNova,
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].vp_valor_parcela);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.ven_vlr_total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  onFecharModalParcela = () => {
    this.setState({
      modalParcelaVisible: false,
    },
      this.calculaTotalParc()
    );
  }

  onEditarParcelaClick = registro => {
    if (((this.state.listaParcelas) && (this.state.listaParcelas.length > 0))) {
      this.setState({
        modalParcelaVisible: true,
      });
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Calcule as Parcelas para Editar' });
    }
  };

  excluirParcelas = () => {
    this.setState({
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['ven_cond_pagto'] = event.ven_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }


  // ----------------------------------------------------------------

  renderValor = (vlr, registro) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    let tamanhos = '';
    for (var x in this.state.listaGrades) {
      if ((this.state.listaGrades[x].vig_item === registro.vi_item) && (this.state.listaGrades[x].vig_seq === registro.vi_seq)) {
        tamanhos = tamanhos + this.state.listaGrades[x].gtp_descricao + '/' + this.state.listaGrades[x].gtam_descricao + '=' + numeral(parseFloat(this.state.listaGrades[x].vig_qtde)).format('0,000.00') + '   ';
      }
    };
    return (
      <span> {tamanhos ? registro.prod_descricao + '  [ ' + tamanhos + ']' : registro.prod_descricao} </span>
    );
  };


  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    const { usuario, carregandoForm, listaProdutos, listaParcelas, listaEntregas, listaGrades, OPCOES_FILIAL,
      produtoSelecionado, produtoEntregaSelecionado, produtoGradeSelecionado,
      vlrDifParc, vlrTotalParc, modalEntregaVisible, modalGradeVisible, modalParcelaVisible, modalProdutoVisible,
      formVisivelProducao, registroSelecionado } = this.state;

    const { ven_idf, ven_numero, ven_dt_venda, ven_pessoa, ven_obs, ven_cond_pagto,
      ven_qtde_itens, ven_vlr_frete, ven_vlr_total, ven_usuario, ven_tipo_venda, ven_filial, ven_tipo_frete, ven_dados_cliente } = this.state.registro;

    // console.log('PedidoForm.this.state: ', this.state);

    return (
      <Modal
        title={ven_idf ? (this.state.visualizando ? "Pedido" : "Edição de Pedido") : "Inclusão de Pedido"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"70%"}
        style={{ top: 10 }}
      >

        {/* <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={'clientes'}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        /> */}

        <PedidoItemForm
          visivel={modalProdutoVisible}
          onSalvarProdutoClick={this.onSalvarProdutoClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoClick}
          produtoSelecionado={produtoSelecionado}
        />

        <PedidoItemEntregaForm
          visivel={modalEntregaVisible}
          onSalvarEntregasClick={this.onSalvarEntregasClick}
          onFecharModalEntregaClick={this.onFecharModalEntregaClick}
          produtoEntregaSelecionado={produtoEntregaSelecionado}
          listaEntregas={listaEntregas}
        />

        <PedidoItemGradeForm
          visivel={modalGradeVisible}
          onSalvarGradeClick={this.onSalvarGradeClick}
          onFecharModalGradeClick={this.onFecharModalGradeClick}
          produtoGradeSelecionado={produtoGradeSelecionado}
          listaGrades={listaGrades}
        />

        <TituloParcelaForm
          visivel={modalParcelaVisible}
          onFecharClick={this.onFecharModalParcela}
          listaParcelas={listaParcelas}
          valor_Total={ven_vlr_total}
          condPagto={ven_cond_pagto}
        />

        <OrdemProducaoForm
          visivel={formVisivelProducao}
          onSalvarClick={this.onSalvarClick}
          onCancelarClick={this.onCancelarClick}
          registroSelecionado={registroSelecionado}
        />


        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <div style={{ height: 350 }}>
                <Form>
                  <Row>
                    <div className="div-subTitulo">
                      <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                        Dados do Pedido
                      </span>
                    </div>

                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        type="number"
                        id="ven_numero"
                        ref="ven_numero"
                        decimalScale={0}
                        maxLength={9}
                        onChange={this.onChange}
                        value={ven_numero}
                        readOnly={usuario && usuario.par_flag_digita_controle_venda ? false : true}
                      />
                    </Col>

                    <Col xs={24} sm={6} style={{ marginTop: 0 }}>
                      <span>Data Pedido</span>
                      <InputForm
                        type="date"
                        id="ven_dt_venda"
                        ref="ven_dt_venda"
                        value={ven_dt_venda}
                        masker={maskDate}
                        validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                        dateFormat="DD/MM/YYYY"
                        onChange={this.onChange}
                        errorMessage="Formato correto DD/MM/AAAA"
                        className="input-data-avaliacao"
                        style={{ width: "100%" }}
                        disabled={ven_idf ? true : false}
                      />
                    </Col>

                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Tipo Pedido</span>
                      <InputForm
                        type="select"
                        id="ven_tipo_venda"
                        ref="ven_tipo_venda"
                        value={ven_tipo_venda}
                        placeholder="Selecione"
                        onChange={this.onChange}
                        data={usuario && usuario.ue_flag_bonificacao ? OPCOES_TIPO : OPCOES_TIPO1}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                      />
                    </Col>

                    <Col xs={24} sm={6} >
                      <span>Tipo Frete</span>
                      <InputForm
                        type="select"
                        id="ven_tipo_frete"
                        ref="ven_tipo_frete"
                        value={ven_tipo_frete}
                        placeholder="Selecione"
                        onChange={this.onChange}
                        data={OPCOES_TIPO_FRETE}
                        validator={value => Boolean(value)}
                        style={{ width: "100%" }}
                      />
                    </Col>

                    <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
                      <PessoaFrame
                        label="Cliente"
                        id="ven_pessoa"
                        value={ven_pessoa}
                        tipo="C"
                        width={"100%"}
                        onChange={this.onChangePessoa}
                        descricaoPrimeiroItem="Selecione um Cliente"
                      />
                    </Col>
                    {/* <Col xs={24} sm={1} style={{ marginTop: 24 }}>
                      <Tooltip title="Cadastro de Clientes" placement="topLeft">
                        <Button
                          type="dashed"
                          icon="plus"
                          htmlType="button"
                          onClick={() => this.onCadPessoaClick()}
                        />
                      </Tooltip>
                    </Col> */}
                    <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                      <UsuarioFrame
                        label="Vendedor"
                        id="ven_usuario"
                        value={ven_usuario}
                        width={"100%"}
                        vendedor={1}
                        todasEmpresas={this.state.usuario ? this.state.usuario.emp_codigo : 999999}
                        onChange={this.onChangeVendedor}
                        descricaoPrimeiroItem="Selecione um Vendedor"
                        disabled={getTemPermissao('UsuarioSupervisor', 'cons') ? false : true}
                      />
                    </Col>

                    {ven_tipo_venda.key === 'O' ? (
                      <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                        <span>Dados do Cliente</span>
                        <InputForm
                          id="ven_dados_cliente"
                          ref="ven_dados_cliente"
                          value={ven_dados_cliente}
                          maxLength={950}
                          onChange={this.onChange}
                          validator={value => Boolean(value)}
                        />
                      </Col>
                    ) : null}

                    <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Quantidade Pordutos</span>
                      <InputForm
                        type="number"
                        id="ven_qtde_itens"
                        ref="ven_qtde_itens"
                        value={ven_qtde_itens}
                        decimalScale={0}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Valor Frete</span>
                      <InputForm
                        type="number"
                        id="ven_vlr_frete"
                        ref="ven_vlr_frete"
                        value={ven_vlr_frete}
                        onChange={this.onChangeFrete}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Valor Total</span>
                      <InputForm
                        type="number"
                        id="ven_vlr_total"
                        ref="ven_vlr_total"
                        value={ven_vlr_total}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>

                    {this.state.usuario && this.state.usuario.emp_filial1 ? (
                      <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                        <span>Filial</span>
                        <InputForm
                          type="select"
                          id="ven_filial"
                          ref="ven_filial"
                          value={ven_filial}
                          placeholder="Selecione"
                          onChange={this.onChange}
                          data={OPCOES_FILIAL}
                          validator={value => Boolean(value)}
                          style={{ width: "100%" }}
                        />
                      </Col>
                    ) : null}


                    <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
                      <CondPagtoFrame
                        label="Condição de Pagamento"
                        id="ven_cond_pagto"
                        value={ven_cond_pagto}
                        pessoa={ven_pessoa.key}
                        width={"100%"}
                        onChange={this.onChangeCondPagto}
                        descricaoPrimeiroItem="Informe a Condição de Pagamento"
                      />
                    </Col>

                    {/* <Col xs={24} sm={this.state.usuario && this.state.usuario.emp_filial1 ? 18 : 24} style={{ marginTop: -20 }}> */}
                    <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                      <span>OBS</span>
                      <InputForm
                        id="ven_obs"
                        ref="ven_obs"
                        value={ven_obs}
                        maxLength={200}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>

                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Lista dos Produtos" key="produtos">
              <div style={{ height: 350 }}>
                {this.state.visualizando ? null : (
                  <Row>
                    <Col xs={24} style={{ marginTop: -60, marginRight: 20 }}>
                      <Button
                        htmlType="button"
                        onClick={this.onNovoProduto}
                        icon="plus"
                        className="botoesModalForm2x"
                      > Novo Produto
                      </Button>
                    </Col>
                  </Row>
                )}
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutos}
                  pagination={false}
                  scroll={{ y: 310 }}
                  rowKey={(listaProdutos => listaProdutos.vi_item)}
                >
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição"
                    render={this.renderDescrProduto}
                    width={160}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="vi_qtde"
                    dataIndex="vi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={70}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="vi_vlr_unit"
                    dataIndex="vi_vlr_unit"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="vi_vlr_desc"
                    dataIndex="vi_vlr_desc"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="vi_vlr_total"
                    dataIndex="vi_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={70}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesProdutos}
                    width={120}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </div>
            </TabPane>



            <TabPane tab="Forma Pagamento" key="formaPagto">
              <div style={{ height: 350 }}>
                <Row>
                  {this.state.visualizando ? null : (
                    <Row>
                      <Col xs={24} style={{ marginTop: -60, marginRight: 20 }}>
                        <Tooltip title="Excluir Parcelas">
                          <Button
                            htmlType="button"
                            onClick={this.excluirParcelas}
                            icon="close"
                            className="botoesModalForm"
                          > Excluir
                          </Button>
                        </Tooltip>
                        <Tooltip title="Editar Parcelas">
                          <Button
                            htmlType="button"
                            onClick={this.onEditarParcelaClick}
                            icon="edit"
                            className="botoesModalForm"
                          > Alterar
                          </Button>
                        </Tooltip>
                        <Tooltip title="Calcular Parcelas">
                          <Button
                            htmlType="button"
                            onClick={this.montaParcelas}
                            icon="calculator"
                            className="botoesModalForm"
                          > Calcular
                          </Button>
                        </Tooltip>
                      </Col>
                    </Row>
                  )}

                  {vlrDifParc === 0 ? null : (
                    <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
                      <Col xs={24}>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                          <span>{this.renderValor(ven_vlr_total)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                          <span>{this.renderValor(vlrTotalParc)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                          <span>{this.renderValor(vlrDifParc)}</span>
                        </Col>
                      </Col>
                    </Row>
                  )}

                  <div>
                    <Table
                      loading={{
                        spinning: carregandoForm,
                        tip: 'Carregando. Aguarde...',
                        size: "large"
                      }}
                      dataSource={listaParcelas}
                      pagination={false}
                      rowKey={(listaParcelas => listaParcelas.vp_parcela)}
                    >
                      <Column
                        key="vp_parcela"
                        dataIndex="vp_parcela"
                        title="Parcela"
                        width={60}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="vp_data_parcela"
                        dataIndex="vp_data_parcela"
                        title="Data Venc"
                        width={80}
                        align="center"
                        className="listaCadastro"
                        render={this.renderData}
                      />
                      <Column
                        key="vp_valor_parcela"
                        dataIndex="vp_valor_parcela"
                        title="Valor Parc"
                        render={this.renderValor}
                        width={80}
                        align="right"
                        className="listaCadastro"
                      />
                    </Table>
                  </div>
                </Row>

              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizando ? null : (
                  <Button
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="botoesModalForm2x"
                  >
                    Salvar Pedido
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PedidoForm.js